import { useMutation, useQuery } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

interface GetAchSettlementsPayload {
  skip?: number;
  take?: number;
  search?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  [key: string]: any;
}

interface GetAchSettlementsResponse {
  data: any[];
  total: number;
}

const getAchSettlementsApi = async (payload: GetAchSettlementsPayload): Promise<GetAchSettlementsResponse> => {
  const response = await httpClient.post<GetAchSettlementsResponse>('api/southern-mint/get-ach-settlements', payload);
  return response.data;
};

export const useAchSettlements = () => {
  return useMutation({
    mutationFn: getAchSettlementsApi,
  });
};
